import Api from "./api";

const employeePath = "/api/v1/employee-activities";
const adminPath = "/api/v1/admin/employee-activities";

const normalizeList = (data) => ({
  items: Array.isArray(data?.items) ? data.items : [],
  today: data?.today || "",
  count: Number.isInteger(data?.count) ? data.count : data?.items?.length || 0,
});

const withoutEmployeeId = ({ employee_id, ...payload }) => payload;

const createActivityApi = (path, includeEmployeeId) => ({
  list: async ({ from, to, employeeId } = {}) => {
    const params = { from, to };
    if (includeEmployeeId && employeeId !== undefined) {
      params.employee_id = employeeId;
    }
    return normalizeList(await Api.get(path, params));
  },
  quotes: async () => Api.get(`${path}/quotes`),
  create: async (payload) => Api.post(path, includeEmployeeId ? payload : withoutEmployeeId(payload)),
  update: async (id, payload) =>
    Api.patch(`${path}/${id}`, includeEmployeeId ? payload : withoutEmployeeId(payload)),
  remove: async (id) => Api.delete(`${path}/${id}`),
});

export const employeeActivityApi = {
  ...createActivityApi(employeePath, false),
  checkStatus: async (runId) => Api.get(`${employeePath}/check/${runId}`),
};
export const adminActivityApi = {
  ...createActivityApi(adminPath, true),
  checkStatus: async (runId) => Api.get(`${adminPath}/check/${runId}`),
};
